import React, { useState, useEffect } from 'react';
import { Box, CircularProgress, Typography, Alert } from '@mui/material';
import "./PaymentWidget.css";

const PaymentWidget = ({
  orderData,
  onPaymentSuccess,
  onPaymentError,
  onProcessingChange
}) => {
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const [error, setError] = useState('');

  const checkoutId = orderData?.data?.checkoutId;
  const integrityId = orderData?.data?.integrityId;

  useEffect(() => {
    // Cleanup existing scripts
    const cleanup = () => {
      const scripts = document.querySelectorAll('script[src*="paymentWidgets.js"]');
      scripts.forEach(script => {
        if (script.parentNode) script.parentNode.removeChild(script);
      });
    };

    cleanup();

    if (!checkoutId) {
      setError('Payment gateway not available. Please try again.');
      return;
    }

    // Configure widget
    window.wpwlOptions = {
      locale: "en",
      style: "plain",
      showCVVHint: true,
      brandDetection: true,
      threeDIframeSize: { width: '100%', height: '400px' },
      onReady: function () {
        setScriptLoaded(true);
      },
      // onSubmit: () => {
      //   if (onProcessingChange) onProcessingChange(true);
      // },
      // onSuccess: (response) => {
      //   if (onProcessingChange) onProcessingChange(false);
      //   if (onPaymentSuccess) onPaymentSuccess(response);
      // },
      // onError: (error) => {
      //   if (onProcessingChange) onProcessingChange(false);
      //   setError(error?.message || 'Payment failed. Please try again.');
      //   if (onPaymentError) onPaymentError(error);
      // },
    };

    // Load script
    const script = document.createElement('script');
    script.src = `https://eu-test.oppwa.com/v1/paymentWidgets.js?checkoutId=${checkoutId}`;
    script.async = true;
    script.crossOrigin = "anonymous";

    if (integrityId && integrityId !== 'true' && integrityId !== 'false') {
      script.integrity = integrityId;
    }

    script.onerror = () => {
      setError('Failed to load payment gateway. Please check your connection.');
    };

    document.body.appendChild(script);

    return cleanup;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutId, integrityId]);

  if (error) {
    return (
      <Alert severity="error" sx={{ borderRadius: 2 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
          Payment Error
        </Typography>
        <Typography variant="body2">{error}</Typography>
      </Alert>
    );
  }

  return (
    <Box className="payment-widget-container">
      <form
        action="https://www.99gift.ae/profile/order"
        className="paymentWidgets"
        data-brands="VISA MASTER AMEX DISCOVER CARTEBANCAIRE"
        method="POST"
      />

      {!scriptLoaded && (
        <Box sx={{ textAlign: 'center', py: 3 }}>
          <CircularProgress size={32} sx={{ color: '#d4af37' }} />
          <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
            Loading payment gateway...
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default PaymentWidget;
